module.exports = __webpack_public_path__ + "ce49bbf726a9a64452da27e0a6791246.png";